import React from 'react'
import { Input, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { formatDateToInputValue } from 'src/utils'
import { birthTypeOptions } from 'src/constants/birthType'
import { filterAnimalsByReproductionAge } from '../utils/functions'
import { useStyles } from './styles'
import { useFormContext } from 'react-hook-form'
import { BirthRegistrationParams } from '.'

interface BirthDataSectionProps {
  selectedAnimalId: string
  isLoadingAnimal: boolean
  dataParto: string
  handleSelectAnimal: (id: string) => void
  validateDateNotFuture: (value: string, fieldName: string, fieldLabel: string) => boolean
}

export const BirthDataSection: React.FC<BirthDataSectionProps> = ({
  selectedAnimalId,
  isLoadingAnimal,
  dataParto,
  handleSelectAnimal,
  validateDateNotFuture
}) => {
  const style = useStyles()

  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<BirthRegistrationParams>()

  const today = new Date().toISOString().split('T')[0]

  return (
    <section className={style.section}>
      <div className={style.sectionHeader}></div>
      <div className={style.infoGrid}>
        <div className={style.formControl}>
          <SelectAnimalFetchInput
            label='Vaca'
            selectBy='id'
            showBy={['cdn', 'nome']}
            filteredSex='Fêmea'
            filter={filterAnimalsByReproductionAge}
            value={selectedAnimalId}
            error={errors?.idAnimal?.message}
            placeholder='Selecionar vaca'
            onChange={(item: any) => {
              handleSelectAnimal(item?.id || '')
            }}
          />
        </div>
        <div className={style.formControl}>
          <Input
            type='date'
            max={today}
            label='Data do Parto'
            value={formatDateToInputValue(dataParto)}
            error={errors?.dataParto?.message}
            disabled={isLoadingAnimal}
            onChange={(value: string) => {
              if (validateDateNotFuture(value, 'dataParto', 'Data do Parto')) {
                setValue('dataParto', value)
                clearErrors('dataParto')
              } else {
                setValue('dataParto', value)
              }
            }}
          />
        </div>
        <div className={style.formControl}>
          <SelectInput
            label='Tipo de Parto'
            value={watch('tipoParto') || ''}
            options={birthTypeOptions.filter((opt) => opt.id === 'normal' || opt.id === 'cesariana')}
            selectBy='id'
            showBy={['value']}
            placeholder='Selecione o tipo de parto'
            error={errors?.tipoParto?.message}
            disabled={isLoadingAnimal}
            onChange={(option: any) => {
              setValue('tipoParto', option?.id || 'normal')
              clearErrors('tipoParto')
            }}
          />
        </div>
      </div>
    </section>
  )
}
